import React from 'react'
import { Input } from 'components/shared/FormFields/common/Input/Input'
import { Icon, SearchIcon, XIcon } from 'components/shared/Icon/Icon'
import styles from './MembersPanel.module.scss'
import cx from 'classnames'
import { t } from 'ttag'
import { Button } from 'components/shared/Button/Button'
import { PlusCircleIcon } from 'components/shared/Icon/Icon'
import { ADMIN_ROLE } from 'constants/users'

export const MembersPanel = ({ state, handlers }) => {
  const { selectedUser, search, members, isSearchFocused } = state
  const { setUser, setSearch, setIsSearchFocused, handleManageUserOpen } =
    handlers

  return (
    <div className={styles.membersPanel}>
      <div className={styles.searchInputContainer}>
        {isSearchFocused || search ? null : (
          <Icon icon={SearchIcon} size={26} className={styles.searchIcon} />
        )}
        {search ? (
          <Icon
            icon={XIcon}
            size={26}
            className={styles.xIcon}
            onClick={() => setSearch('')}
          />
        ) : null}
        <Input
          fieldClassName={styles.searchInput}
          name={'members'}
          onChange={e => setSearch(e.target.value)}
          value={search}
          onFocus={() => setIsSearchFocused(true)}
          onBlur={() => setIsSearchFocused(false)}
        />
      </div>
      <div className={styles.mamberCards}>
        {members?.length > 0 ? (
          members.map(({ id, first_name, last_name, role }) => {
            const isAdmin = role === ADMIN_ROLE

            return (
              <>
                <div
                  className={cx(styles.mamberCard, {
                    [styles.selected]: selectedUser?.id === id,
                  })}
                  key={id}
                  onClick={() => setUser(id)}
                >
                  <span>{`${first_name} ${last_name}`}</span>
                  {isAdmin ? (
                    <div className={styles.adminLabel}>ADMIN</div>
                  ) : null}
                </div>
              </>
            )
          })
        ) : (
          <div
            className={styles.noUsers}
          >{t`No non-admin users in the organisation. You can add them below.`}</div>
        )}
      </div>
      <Button
        color="primary"
        icon={PlusCircleIcon}
        className={styles.addUser}
        label={t`Add user`}
        size="medium"
        variant="filled"
        onClick={() => handleManageUserOpen(false)}
      />
    </div>
  )
}
